import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { Card } from './ui';
import { Send, Trash2, MessageSquare } from 'lucide-react';

const Kommentarer = ({ entitet, entitetId }) => {
  const [liste, setListe] = useState([]);
  const [tekst, setTekst] = useState('');
  const [busy, setBusy] = useState(false);

  const last = () => {
    if (!entitetId) return;
    api.get(`/kommentarer/${entitet}/${entitetId}`)
      .then((r) => setListe(r.data))
      .catch(() => setListe([]));
  };
  useEffect(() => { last(); /* eslint-disable-next-line */ }, [entitet, entitetId]);

  const send = async () => {
    if (!tekst.trim()) return;
    setBusy(true);
    try {
      await api.post(`/kommentarer/${entitet}/${entitetId}`, { tekst });
      setTekst('');
      last();
    } finally { setBusy(false); }
  };
  const slett = async (k) => {
    if (!window.confirm('Slett kommentar?')) return;
    try { await api.delete(`/kommentarer/${k.id}`); last(); }
    catch (e) { alert(e.response?.data?.error || 'Feil.'); }
  };

  const fmt = (iso) => {
    try { return new Date(iso).toLocaleString('nb-NO'); }
    catch { return iso; }
  };

  return (
    <Card style={{ marginTop: 12 }} className="no-print">
      <h3 style={{ margin: '0 0 8px', fontSize: 12, fontWeight: 600,
                   display: 'flex', alignItems: 'center', gap: 6 }}>
        <MessageSquare size={13} /> Kommentarer ({liste.length})
      </h3>
      {liste.length === 0 && (
        <p className="fm-text-muted" style={{ fontSize: 11, margin: '0 0 8px' }}>
          Ingen kommentarer enda. Skriv en notat som er synlig for andre brukere.
        </p>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 10 }}>
        {liste.map((k) => (
          <div key={k.id} style={{
            padding: '6px 8px', border: '1px solid var(--theme-border)', borderRadius: 4,
            background: 'var(--theme-bg-secondary, transparent)',
          }}>
            <div className="flex items-center justify-between" style={{ marginBottom: 2 }}>
              <strong style={{ fontSize: 11 }}>{k.bruker_navn || 'Anonym'}</strong>
              <div className="flex items-center" style={{ gap: 6 }}>
                <span className="fm-text-muted" style={{ fontSize: 10 }}>{fmt(k.opprettet)}</span>
                <button className="btn-ghost" onClick={() => slett(k)} title="Slett"
                        style={{ padding: 2, color: 'var(--theme-danger)' }}>
                  <Trash2 size={11} />
                </button>
              </div>
            </div>
            <div style={{ fontSize: 12, whiteSpace: 'pre-wrap' }}>{k.tekst}</div>
          </div>
        ))}
      </div>
      <div className="flex" style={{ gap: 6 }}>
        <textarea value={tekst} onChange={(e) => setTekst(e.target.value)}
                  placeholder="Skriv en kommentar…" rows={2} style={{ flex: 1, fontSize: 12 }} />
        <button className="btn-primary" onClick={send} disabled={busy || !tekst.trim()}>
          <Send size={12} /> Send
        </button>
      </div>
    </Card>
  );
};

export default Kommentarer;
